export default __webpack_public_path__ + "static/media/quiz-q20.d94ae8fd.png";